module.exports = __webpack_public_path__ + "static/media/sygnet.b61d10e4.png";